import { Pressable } from '@react-aria/interactions'

import Styles from './SupportChat.module.scss'
import { useOnboardingTracking } from 'hooks/useOnboardingTracking'

export const INTERCOM_AUTOPILOT_ONBOARDING_MESSAGE = 'Hello! Can you help me with my autopilot onboarding?'

export const SupportChat = ({ mobile = false }: { mobile?: boolean }) => {
  const text = mobile ? 'Live Help' : 'Get Live Help'
  const { trackSupportClicked } = useOnboardingTracking()

  return (
    <Pressable
      onPress={() => {
        trackSupportClicked()
        window.Intercom('showNewMessage', INTERCOM_AUTOPILOT_ONBOARDING_MESSAGE)
      }}
    >
      <div className={Styles.supportButton}>
        <img
          className={Styles.avatar}
          src="https://res.cloudinary.com/almanac/image/upload/v1754670425/onboarding_assets/sider_component/support_avatar_cbq4wg.png"
          alt="Support Avatar"
        />
        <span className={Styles.text}>{text}</span>
      </div>
    </Pressable>
  )
}
